import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

declare var jQuery: any;

@Component({
  selector: 'app-register-user-message',
  templateUrl: './register-user-message.component.html',
  styleUrls: ['./register-user-message.component.css']
})
export class RegisterUserMessageComponent implements OnInit {

  public message : string;

  public srcImage : string;

  public widthImage : string;
 
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
  ) { }

  ngOnInit() {

    this.message =  sessionStorage.getItem('messageRegisterUser');
    this.srcImage =  sessionStorage.getItem('srcImageRegisterUser');
    this.widthImage =  sessionStorage.getItem('widthImageRegisterUser');   

   if(this.message === null || this.srcImage === null || this.widthImage === null){
      this.message = '<b>Lo Sentimos:</b><br/><br/><p align="justify">No hay datos que mostrar</p>';
      this.srcImage = 'warning';
      this.widthImage = '100';
   }

    jQuery("#divMessage").html(this.message);
  }

  nuevoRegistro(){
    sessionStorage.clear();
    this._router.navigate(['/auth/register/user']);    
  }

  finalizarRegistro(){
    sessionStorage.clear();
    this._router.navigate(['/auth/sign_in']);    
  }

}



// WEBPACK FOOTER //
// /app/src/app/auth/register-user-message/register-user-message.component.ts